<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">{{ 'ViewUser' | translate}}</h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
        <mat-card-content class="mat-mdc-card-content text-center">
            <div class="container">
                <div class="profile-header">
                    <h1>{{UserInfo.userName}}</h1>
                </div>

                <div class="info">
                    <h2>{{ 'ContactInformation' | translate }}</h2>
                    <p>
                        <mat-label class="spanTitle">{{ 'Phone' | translate }} : </mat-label>
                        {{UserInfo.phoneNumber}}
                    </p>
                    <p>
                        <mat-label class="spanTitle">{{ 'Email' | translate }} : </mat-label>
                        {{UserInfo.email}}
                    </p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-divider></mat-divider>

    <div class="row m-t-24">
        <div class="col-sm-12">
            <button mat-button class="Cancelbtn" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
        </div>
    </div>
</mat-dialog-content>